/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import * as moment from 'moment';

let clockInternal;
export default class LiveClock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayDateTime : '',
            displayDateTimeFormat : 'DD MMM YYYY HH:mm:ss',
        };
    }
    componentDidMount(){
        this.setState({ displayDateTime : moment().format((!!this.props.format ? this.props.format : 'DD MMM YYYY HH:mm:ss')), 
            displayDateTimeFormat : (!!this.props.format ? this.props.format : 'DD MMM YYYY HH:mm:ss')}, () =>{
                this.startClock()
        });
    }
    startClock(){
        const self = this;
        clockInternal = setInterval(function(){
            clearInterval(clockInternal);
            self.setState({ displayDateTime : moment().format(self.state.displayDateTimeFormat)},()=>{
                self.startClock();
            });
        }, 500);
    }
    componentWillUnmount(){
        clearInterval(clockInternal);
    }
    render() {
        return (
            <span>
                {this.state.displayDateTime}
            </span>
        )
    }
}
